import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  type: "submit",
  class: "card-edit-popup__btn btns btns--large"
}

import { ref, useTemplateRef } from 'vue'
import { useWait } from '@/app/composables/useWait'

import type { BillingView } from '@/models/billing'
import { ValidationState } from '@/helpers/form'

import FormError from '@/components/ui/FormError.vue'
import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'
import StripeCard from '@/app/components/billing/StripeCard.vue'
import StripeCardInfo from '@/app/components/billing/StripeCardInfo.vue'
import BasePopup from '@/components/ui/BasePopup.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CardEditPopup',
  props: {
    billing: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const wait = useWait()

const popup = useTemplateRef('popup')
const stripeCard = useTemplateRef('stripeCard')

const validation = ref(new ValidationState())

function show(): void {
  props.billing.cardEditMode = true
  popup.value?.show()
}

function hide(): void {
  props.billing.cardEditMode = false
  popup.value?.hide()
}

async function submitForm(event: Event): Promise<void> {
  event.preventDefault()
  await subscribe()
}

async function subscribe(): Promise<void> {
  try {
    wait.start('Saving')
    let hideDialog: boolean = true
    if (props.billing.cardEditMode && stripeCard.value?.needsSaving()) {
      const result = await stripeCard.value?.save()
      if (result !== true) {
        hideDialog = false
      }
    }
    if (hideDialog) {
      hide()
    }
    wait.end('Saving')
  } catch (error) {
    wait.end('Saving')
    validation.value.showErrors(error)
  }
}

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!
  const _directive_wait = _resolveDirective("wait")!

  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "popup",
    ref: popup,
    class: "card-edit-popup",
    title: "Edit your credit card",
    compact: true
  }, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("p", null, " If you want to update your credit card used for your subscription, please do it below. ", -1)),
      _createElementVNode("form", {
        class: "card-edit-popup__form",
        onSubmit: submitForm
      }, [
        (popup.value?.isVisible && __props.billing.cardEditMode)
          ? (_openBlock(), _createBlock(StripeCard, {
              key: 0,
              ref_key: "stripeCard",
              ref: stripeCard,
              billing: __props.billing,
              "show-button": false
            }, null, 8, ["billing"]))
          : (_openBlock(), _createBlock(StripeCardInfo, {
              key: 1,
              ref: "stripeCardInfo",
              billing: __props.billing
            }, null, 8, ["billing"])),
        _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_1, [
          _createVNode(_component_v_wait, { for: "Saving" }, {
            waiting: _withCtx(() => [
              _cache[0] || (_cache[0] = _createTextVNode(" Saving ", -1)),
              _createVNode(ButtonSpinner)
            ]),
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "Save", -1))
            ]),
            _: 1
          })
        ])), [
          [_directive_wait, 'Saving', "disabled"]
        ]),
        _createVNode(FormError, {
          errors: validation.value.errors,
          field: __props.billing.plan.id
        }, null, 8, ["errors", "field"])
      ], 32)
    ]),
    _: 1
  }, 512))
}
}

})